

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CCbl8yxr.js","_app/immutable/chunks/disclose-version.DZaQXHkE.js","_app/immutable/chunks/runtime.CkDI4bGX.js","_app/immutable/chunks/legacy.CMQtmpCj.js","_app/immutable/chunks/render.BHL7ctEy.js","_app/immutable/chunks/lifecycle.PEt4dGlZ.js","_app/immutable/chunks/entry.DXA7jFky.js","_app/immutable/chunks/index-client.i0OL8c_P.js"];
export const stylesheets = [];
export const fonts = [];
